import axios from 'axios';
import React, { useState } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import settingSystem from "../SettingSystem.js"

const BRUSH_TYPE_DRAW = 0;
const BRUSH_TYPE_HIGHLIGHT = 1;
const BRUSH_TYPE_ERASE = 2;

export default class AnnotationCanvas extends React.Component {
	
	state = {
		resetCanvasConfirmDialogOpened: false,
	};

	constructor(props) {
		super(props);

		AnnotationCanvas.singleton = this;

		settingSystem.registerMember("annotationDisabled", this, "disabled");
		settingSystem.registerMember("annotationBrushType", this, "brushType");
		settingSystem.registerMember("annotationBrushColor", this, "brushColor");
		settingSystem.registerMember("annotationBrushSize", this, "brushSize");
	}
	
	anythingOnCanvas = false;
	referenceCanvas = this.props.referenceCanvas;
	
	canvasRef = React.createRef();
	highlightCanvasRef = React.createRef();
	
	scrollBox = this.props.scrollBox || {scrollTop:0};
	
	disabled = true;
	_brushType = BRUSH_TYPE_DRAW;
	_brushColor = "black";
	_brushSize = 2;
	
	lastPosition = {x: NaN, y: NaN};
	position = {x: NaN, y: NaN};

	// lastCanvas = null;
	// lastHighlightCanvas = null;

	MAX_HISTORY = 20;
	history = [];
	historyOffset = 0; // bigger means deeper (eariler)

	canvasHistorySnapshot = null;
	highlightCanvasHistorySnapshot = null;
	
	set brushType(type) {
		if (type == BRUSH_TYPE_HIGHLIGHT) {
			this.brushColor = "gold";
		}

		if (type == BRUSH_TYPE_DRAW && this._brushType == BRUSH_TYPE_HIGHLIGHT) {
			this.brushColor = "black";
		}

		this._brushType = type;
	}

	get brushType() {
		return this._brushType;
	}
	
	set brushColor(color) {
		this._brushColor = color;
		this.updateBrush();
	}
	
	get brushColor() {
		return this._brushColor;
	}
	
	set brushSize(size) {
		this._brushSize = size;
		this.updateBrush();
	}
	
	get brushSize() {
		return this._brushSize;
	}
	
	updateBrush() {
		this._updateBrush(this.canvasRef.current);
		this._updateBrush(this.highlightCanvasRef.current);
	}
	
	_updateBrush(canvas) {
		var canvasContext = canvas.getContext("2d");
		
		canvasContext.lineWidth = this._brushSize;
		
		canvasContext.lineJoin = 'round';
		canvasContext.lineCap = 'round';
		canvasContext.strokeStyle = this._brushColor;
	}
	
	resetCanvas() {
		this.anythingOnCanvas = false;
		this.history = [];
		this.historyOffset = 0;
		
		this._resetCanvas(this.canvasRef.current);
		this._resetCanvas(this.highlightCanvasRef.current);

		if (this.canvasHistorySnapshot != null) {
			this._resetCanvas(this.canvasHistorySnapshot);
		}
		if (this.highlightCanvasHistorySnapshot != null) {
			this._resetCanvas(this.highlightCanvasHistorySnapshot);
		}
	}
	
	_resetCanvas(canvas) {
		if (this.props.referenceCanvas == null) {
			return;
		}
		
		var canvasContext = canvas.getContext("2d");
		
		canvas.width = this.referenceCanvas.offsetWidth;
		canvas.height = this.referenceCanvas.offsetHeight;
		
		this.updateBrush();
			
		canvasContext.clearRect(0, 0, canvas.width, canvas.height);
		
		this.resetPosition();
	}
	
	resetPosition = () => {
		this.lastPosition = {x: NaN, y: NaN};
		this.position = {x: NaN, y: NaN};
	}

	promptClearCanvas() {
		if (this.anythingOnCanvas) {
			this.setState({resetCanvasConfirmDialogOpened: true});
		}
	}

	// static createResetConfirmDialog(openState, closeFunc, confirmFunc) {
	// 	return <Dialog
	// 		open={openState}
	// 		onClose={closeFunc}
	// 	>
	// 		<DialogTitle>
	// 			Delete all annotations
	// 		</DialogTitle>
	// 		<DialogContent>
	// 			<DialogContentText>
	// 				{"The score has been resized, thus the annotations may not be positioned correctly anymore. Do you want to clear the annotations?"}
	// 			</DialogContentText>
	// 		</DialogContent>
	// 		<DialogActions>
	// 			<Button variant="contained" onClick={confirmFunc}>Confirm</Button>
	// 			<Button variant="outlined" onClick={closeFunc} autoFocus>Cancel</Button>
	// 		</DialogActions>
	// 	</Dialog>
	// }

	cloneCanvas(oldCanvas) {

		//create a new canvas
		var newCanvas = document.createElement('canvas');
		var context = newCanvas.getContext('2d');
	
		//set dimensions
		newCanvas.width = oldCanvas.width;
		newCanvas.height = oldCanvas.height;
	
		//apply the old canvas to the new one
		context.drawImage(oldCanvas, 0, 0);
	
		//return the new canvas
		return newCanvas;
	}

	// undo() {
	// 	const canvas = this.canvasRef.current;
	// 	var context = canvas.getContext('2d');

	// 	context.clearRect(0, 0, canvas.width, canvas.height);
	
	// 	context.drawImage(this.lastCanvas, 0, 0);
	// }

	undo() {
		const canvas = this.canvasRef.current;
		const highlightCanvas = this.highlightCanvasRef.current;

		// var canvasContext = canvas.getContext("2d");
		// canvasContext.clearRect(0, 0, canvas.width, canvas.height);

		// var highLightCanvasContext = highlightCanvas.getContext("2d");
		// highLightCanvasContext.clearRect(0, 0, highlightCanvas.width, highlightCanvas.height);

		this.historyOffset++;
		if (this.historyOffset > this.history.length) {
			this.historyOffset = this.history.length;
		}

		this.drawWithHistory(this.history, this.historyOffset, canvas, highlightCanvas, true);

		// this.history.pop();
	}

	redo() {
		const canvas = this.canvasRef.current;
		const highlightCanvas = this.highlightCanvasRef.current;

		// var canvasContext = canvas.getContext("2d");
		// canvasContext.clearRect(0, 0, canvas.width, canvas.height);

		// var highLightCanvasContext = highlightCanvas.getContext("2d");
		// highLightCanvasContext.clearRect(0, 0, highlightCanvas.width, highlightCanvas.height);

		this.historyOffset--;
		if (this.historyOffset < 0) {
			this.historyOffset = 0;
		}

		this.drawWithHistory(this.history, this.historyOffset, canvas, highlightCanvas, true);

		// this.history.pop();

	}

	drawWithHistory(history, offset, canvas, highlightCanvas, needClear) {
		const originalBrushSize = this.brushSize;
		const originalBrushColor = this.brushColor;

		var canvasContext = canvas.getContext("2d");
		var highLightCanvasContext = highlightCanvas.getContext("2d");
		
		if (needClear) {
			canvasContext.clearRect(0, 0, canvas.width, canvas.height);
			highLightCanvasContext.clearRect(0, 0, highlightCanvas.width, highlightCanvas.height);

			canvasContext.drawImage(this.canvasHistorySnapshot, 0, 0);
			highLightCanvasContext.drawImage(this.highlightCanvasHistorySnapshot, 0, 0);
		}
		
		for (let i = 0; i < history.length - offset; i++) {
			const historyEntry = history[i];

			this._brushSize = historyEntry.size;
			this._brushColor = historyEntry.color;

			this._updateBrush(canvas);
			this._updateBrush(highlightCanvas);

			const lines = historyEntry.lines;

			if (historyEntry.type == BRUSH_TYPE_DRAW) {
				canvasContext.beginPath();

				for (let j = 0; j < lines.length; j++) {
					const line = lines[j];

					canvasContext.moveTo(line.x1, line.y1);
					canvasContext.lineTo(line.x2, line.y2);
				}
				canvasContext.closePath();
				canvasContext.stroke();

			} else if (historyEntry.type == BRUSH_TYPE_HIGHLIGHT) {
				highLightCanvasContext.lineWidth = this._brushSize * 10.0;
				
				highLightCanvasContext.beginPath();
				
				for (let j = 0; j < lines.length; j++) {
					const line = lines[j];

					highLightCanvasContext.moveTo(line.x1, line.y1);
					highLightCanvasContext.lineTo(line.x2, line.y2);
				}

				highLightCanvasContext.closePath();
				highLightCanvasContext.stroke();
				
				highLightCanvasContext.lineWidth = this._brushSize;
				
			} else if (historyEntry.type == BRUSH_TYPE_ERASE) {
				
				const erase = (c) => {
					c.lineWidth = 20.0;
					
					c.save();
					c.globalCompositeOperation = 'destination-out';
					c.beginPath();
					for (let j = 0; j < lines.length; j++) {
						const line = lines[j];
	
						c.moveTo(line.x1, line.y1);
						c.lineTo(line.x2, line.y2);
					}
					c.closePath();
					c.stroke();
					c.restore();
					
					c.lineWidth = this._brushSize;
				}
				
				erase(canvas.getContext("2d"));
				erase(highlightCanvas.getContext("2d"));
			}	
		}

		this._brushSize = originalBrushSize;
		this._brushColor = originalBrushColor;

		this._updateBrush(canvas);
		this._updateBrush(highlightCanvas);
	}

	resetRedoHistory() {
		// remove the history entries that can be redo
		if (this.historyOffset > 0) {
			this.history = this.history.slice(0, -this.historyOffset);
		}

		this.historyOffset = 0;
	}

	AddPlaceholderHistoryEntry() {
		this.history.push({
			type: this.brushType,
			size: this.brushSize,
			color: this.brushColor,
			lines: [],
		});

		while (this.history.length > this.MAX_HISTORY) {
			const overflownHistoryEntry = this.history.shift();
			
			this.drawWithHistory(
				[overflownHistoryEntry], 0,
				this.canvasHistorySnapshot,
				this.highlightCanvasHistorySnapshot,
				false
			);

			// var image = this.highlightCanvasHistorySnapshot.toDataURL("image/png").replace("image/png", "image/octet-stream");
			// window.location.href=image; // it will save locally

		}

		console.log("Annotation history count: " + this.history.length);
	}

	GetUndoAvailable() {
		return this.history.length - this.historyOffset > 0;
	}

	GetRedoAvailable() {
		return  this.history.length > 1 && this.historyOffset > 0;
	}

	componentDidMount() {
		var canvas = this.canvasRef.current;
		var highlightCanvas = this.highlightCanvasRef.current;
		
		this.resetCanvas();

		this.canvasHistorySnapshot = document.createElement('canvas');
		this.canvasHistorySnapshot.width = canvas.width;
		this.canvasHistorySnapshot.height = canvas.height;

		this.highlightCanvasHistorySnapshot = document.createElement('canvas');
		this.highlightCanvasHistorySnapshot.width = canvas.width;
		this.highlightCanvasHistorySnapshot.height = canvas.height;
		
		// console.log(window.getComputedStyle(osmdCanvas, null).height);
		
		///////////////
		
		canvas.addEventListener('mousemove', (e) => {
			if (this.disabled) {
				return;
			}
			
			this.lastPosition.x = this.position.x;
			this.lastPosition.y = this.position.y;
			
			this.position.x = e.pageX - canvas.offsetLeft;
			this.position.y = e.pageY - canvas.offsetTop + this.scrollBox.scrollTop;
			
		}, false);
		
		canvas.addEventListener('mouseleave', (e) => {
			if (this.disabled) {
				return;
			}
			
			canvas.removeEventListener('mousemove', onPaint, false);
			
		}, false);
		
		canvas.addEventListener('touchmove', (e) => {
			if (this.disabled) {
				return;
			}
			
			this.lastPosition.x = this.position.x;
			this.lastPosition.y = this.position.y;
			
			var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
			var touch = evt.touches[0] || evt.changedTouches[0];
			
			this.position.x = touch.pageX - canvas.offsetLeft;
			this.position.y = touch.pageY - canvas.offsetTop + this.scrollBox.scrollTop;
			
			e.preventDefault();
			
			if (!isNaN(this.lastPosition.x) && !isNaN(this.lastPosition.y)) {
				onPaint();
			}
		}, false);
		
		canvas.addEventListener('mousedown', (e) => {
			if (this.disabled) {
				return;
			}
			
			if (e.button == 0) {
				// this.lastCanvas = this.cloneCanvas(this.canvasRef.current);

				this.resetRedoHistory();
				this.AddPlaceholderHistoryEntry();

				canvas.addEventListener('mousemove', onPaint, false);
			} else {
				this.resetPosition();
			}
			
			e.stopPropagation();
		}, false);
		
		canvas.addEventListener('mouseup', (e) => {
			if (this.disabled) {
				return;
			}

			if (e.button == 0) {
				canvas.removeEventListener('mousemove', onPaint, false);

			} else {
				this.resetPosition();
			}
			
			e.stopPropagation();
		}, false);
		
		canvas.addEventListener('touchstart', (e) => {
			if (this.disabled) {
				return;
			}

			// this.lastCanvas = this.cloneCanvas(this.canvasRef.current);
		}, false);
		
		canvas.addEventListener('touchend', (e) => {
			if (this.disabled) {
				return;
			}
			
			this.resetPosition();
		}, false);
		
		var onPaint =  (e) => {
			if (this.disabled) {
				return;
			}
			
			this.anythingOnCanvas = true;
			
			if (this.brushType == BRUSH_TYPE_DRAW) {
				var canvasContext = canvas.getContext("2d");
				
				canvasContext.beginPath();
				canvasContext.moveTo(this.lastPosition.x, this.lastPosition.y);
				canvasContext.lineTo(this.position.x, this.position.y);
				canvasContext.closePath();
				canvasContext.stroke();

			} else if (this.brushType == BRUSH_TYPE_HIGHLIGHT) {
				var canvasContext = highlightCanvas.getContext("2d");
				
				canvasContext.lineWidth = this._brushSize * 10.0;
				
				canvasContext.beginPath();
				canvasContext.moveTo(this.lastPosition.x, this.lastPosition.y);
				canvasContext.lineTo(this.position.x, this.position.y);
				canvasContext.closePath();
				canvasContext.stroke();
				
				canvasContext.lineWidth = this._brushSize;
				
			} else if (this.brushType == BRUSH_TYPE_ERASE) {
				
				const erase = (canvasContext) => {
					canvasContext.lineWidth = 20.0;
					
					canvasContext.save();
					canvasContext.globalCompositeOperation = 'destination-out';
					canvasContext.beginPath();
					canvasContext.moveTo(this.lastPosition.x, this.lastPosition.y);
					canvasContext.lineTo(this.position.x, this.position.y);
					canvasContext.closePath();
					canvasContext.stroke();
					canvasContext.restore();
					
					canvasContext.lineWidth = this._brushSize;
				}
				
				erase(canvas.getContext("2d"));
				erase(highlightCanvas.getContext("2d"));
			}		
			
			this.history[this.history.length-1].lines.push({
				x1: this.lastPosition.x,
				y1: this.lastPosition.y,
				x2: this.position.x,
				y2: this.position.y,
			});
		};
		
		// window.addEventListener('resize', (e)=>{
		// 	if (this.anythingOnCanvas) {
		// 		this.setState({resetCanvasConfirmDialogOpened: true});
		// 	}
		// });

	}
	
	
	render() {
		
		const closeConfirmDialog = () => {
			this.setState({resetCanvasConfirmDialogOpened: false});
		};
		
		return (
			<div>
				<canvas ref={this.canvasRef} style={{
					// width: "1000px",
					// height: "1000px",
					position: "absolute",
					zIndex: 2,
					top: 0,
					left: 0,
				}}/>
				
				<canvas ref={this.highlightCanvasRef} style={{
					// width: "1000px",
					// height: "1000px",
					position: "absolute",
					zIndex: 1,
					top: 0,
					left: 0,
					mixBlendMode: "multiply",
				}}/>
				
				<Dialog
					open={this.state.resetCanvasConfirmDialogOpened}
					onClose={closeConfirmDialog}
				>
					<DialogTitle>
						Delete all annotations
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							{"The score has been resized, thus the annotations may not be positioned correctly anymore. Do you want to clear the annotations?"}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button variant="contained" onClick={() => {
							this.resetCanvas();
							closeConfirmDialog();
						}}>Confirm</Button>
						<Button variant="outlined" onClick={closeConfirmDialog} autoFocus>Cancel</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
};